(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.boundSetHeaderHeight = this.setHeaderHeight.bind(this);
      this.boundOnScroll = this.onScroll.bind(this);
      this.boundHandleKeyUp = this.handleKeyUp.bind(this);
      this.boundHandlePageShow = this.handlePageShow.bind(this);
    }

    connectedCallback() {
      this.header = this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

      this.setHeaderHeight();
      requestAnimationFrame(() => this.setHeaderHeight());
      setTimeout(() => this.setHeaderHeight(), 150);

      if (this.headerIsAlwaysSticky) {
        const sectionHeader = this.closest('.section-header');
        if (sectionHeader) sectionHeader.classList.add('shopify-section-header-sticky');
      }

      window.addEventListener('scroll', this.boundOnScroll, false);
      window.addEventListener('resize', this.boundSetHeaderHeight);
      window.addEventListener('load', this.boundSetHeaderHeight);
      document.addEventListener('keyup', this.boundHandleKeyUp);
      window.addEventListener('pageshow', this.boundHandlePageShow);

      this.lockDrawerScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.boundOnScroll, false);
      window.removeEventListener('resize', this.boundSetHeaderHeight);
      window.removeEventListener('load', this.boundSetHeaderHeight);
      document.removeEventListener('keyup', this.boundHandleKeyUp);
      window.removeEventListener('pageshow', this.boundHandlePageShow);
    }

    setHeaderHeight() {
      const height = this.offsetHeight || this.querySelector('.header')?.offsetHeight || 78;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    onScroll() {
      const sectionHeader = this.closest('.section-header');
      if (!sectionHeader) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 40) {
        sectionHeader.classList.add('scrolled-past-header');
      } else {
        sectionHeader.classList.remove('scrolled-past-header');
      }
    }

    handleKeyUp(event) {
      if (event.key === 'Escape') {
        document.documentElement.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll');
      }
    }

    handlePageShow() {
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('no-scroll');
    }

    lockDrawerScroll() {
      const drawerDetails = this.querySelector('details');
      if (!drawerDetails) return;

      const syncScrollState = () => {
        const isOpen = drawerDetails.hasAttribute('open');
        document.documentElement.classList.toggle('no-scroll', isOpen);
        document.body.classList.toggle('no-scroll', isOpen);
        this.setHeaderHeight();
      };

      syncScrollState();
      drawerDetails.addEventListener('toggle', syncScrollState);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
